import styled from 'styled-components';

import CheckFillCircleIcon from 'assets/images/icons/check-fill-circle.svg?react';
import XCircleFillIcon from 'assets/images/icons/x-circle-fill.svg?react';
import theme from 'styles/theme';

export const CheckFillCircleIconStyled = styled(CheckFillCircleIcon)`
  color: ${theme.colors.hostfullyGreen};
`;

export const XCircleFillIconStyled = styled(XCircleFillIcon)`
  color: ${theme.colors.hostfullyOrange};
`;
